<template>
  <div class="benchmark-card">
    <h3 class="benchmark-card__title">{{ title }}</h3>
    <div class="benchmark-card__content">
      <div class="benchmark-card__value" :class="benchmarkClass">
        {{ Math.abs(benchmarkValue) }}%
      </div>
      <div class="benchmark-card__label">
        {{ benchmarkLabel }}
      </div>
      <div v-if="showWarning" class="benchmark-card__warning">
        Concerning - Above Market
      </div>
      <div class="benchmark-card__subtitle">
        PORTFOLIO VS MARKET RATE
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BenchmarkCard',

  props: {
    title: {
      type: String,
      default: 'Project Benchmark to Market'
    },
    benchmark: {
      type: [Number, String],
      default: 0
    }
  },

  mounted() {
    console.log('BenchmarkCard mounted with benchmark:', this.benchmark);
  },

  computed: {
    benchmarkValue() {
      return parseFloat(this.benchmark) || 0;
    },

    benchmarkStatus() {
      if (this.benchmarkValue > 0) return 'over';
      if (this.benchmarkValue < 0) return 'under';
      return 'at';
    },

    benchmarkClass() {
      return `benchmark-card__value--${this.benchmarkStatus}`;
    },

    benchmarkLabel() {
      if (this.benchmarkValue > 0) return 'OVER MARKET';
      if (this.benchmarkValue < 0) return 'UNDER MARKET';
      return 'AT MARKET';
    },

    showWarning() {
      return this.benchmarkValue > 20;
    }
  }
};
</script>
